
  import { defineComponent, PropType } from 'vue';

  import { TSelectOption } from '../types/select';
  import SelectMultiComponent from './SelectMultiComponent.vue';

  export default defineComponent({
    components: {
      SelectMultiComponent,
    },
    name: 'SelectMultiComponentDashed',
    emits: ['update:modelValue'],
    props: {
      title: {
        type: String,
        required: true,
      },
      options: {
        type: Array as PropType<TSelectOption[]>,
        required: true,
      },
      canClearSelect: {
        type: Boolean,
        default: false,
      },
      modelValue: {
        type: Number,
        required: true,
      },
    },
    computed: {
      model: {
        get() {
          return this.modelValue;
        },
        set(value: number) {
          this.$emit('update:modelValue', value);
        },
      },
    },
  });
